// Get Documents Use Case

import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import DocumentUploadRepository from "@/core/customers/repositories/DocumentUploadRepository";
import { DocumentsListResponse } from "@/core/customers/entities/DocumentUpload";

export default class GetDocumentsUseCase {
  constructor(
    private readonly documentUploadRepository: DocumentUploadRepository
  ) {}

  /**
   * Executes the get documents use case.
   *
   * @param customerId - Customer ID to fetch documents for
   * @returns A promise resolving with DocumentsListResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(customerId: string): Promise<DocumentsListResponse> {
    try {
      return await this.documentUploadRepository.getDocuments(customerId);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
